export const append = (buttonElement) => {
  createUnreadBadge(buttonElement)
    .classed("unread-badge", true)
    .attr("x", (d) => d.width)
    .style("pointer-events", "none")

  computeAttributes(buttonElement)
}

export const computeAttributes = (buttonElement) => {
  buttonElement.select(".unread-badge").attr("transform", (d) => `translate(${d.width - 10},0)`)
}

const createUnreadBadge = (buttonElement) => {
  const unreadBadgeElement = buttonElement.append("g")
  unreadBadgeElement.append("circle").attr("cx", 5).attr("cy", 5).attr("r", 10)
  return unreadBadgeElement
}
